import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">页面未找到</h1>
        <p className="text-foreground-500 mb-8">你访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}